import { useState, useEffect } from 'react';
import { getApiBaseUrl } from '../utils/Config';
import { useApiFetch } from '../utils/useApiFetch';

function useProfilePic(apiCandidateID, refetchTrigger) {
    const [profilePicUrl, setProfilePicUrl] = useState(null);
    const baseUrl = getApiBaseUrl();
    const apiFetch = useApiFetch();

    useEffect(() => {
        if (!apiCandidateID) return;

        const fetchProfilePic = async () => {
            try {
                const response = await apiFetch(
                    `${baseUrl}/api/Attachment/GetCandidateProfilePicture?candidateId=${apiCandidateID}`,
                    { mode: 'cors' }
                );
                const data = await response.json();
                setProfilePicUrl(data.result);
            } catch (error) {
                console.error("Failed to fetch profile pic URL:", error);
            }
        };

        fetchProfilePic();
    }, [apiCandidateID, baseUrl, refetchTrigger]);

    return profilePicUrl;
}

export default useProfilePic;
